import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import { fetchMemberLogsData } from "../../redux/reducers/apiSlice";
import MemberTableFilters from "./MemberTableFilters";
import ProfileInfo from "./common/ProfileInfo";
import MemberCheckinLogs from "../pt-trials/common/MemberCheckinLogs";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import {
  convertStraight,
  convertTimeRangeHHMMSS,
  convertToYYYYMMDD,
} from "../common-data/Converts";

const MemberDetail = ({
  user,
  prevClickValues,
  prevFilters,
  trainerInfo,
  isNotAssignedMembers,
  onClosePrevModal,
}) => {
  const dispatch = useDispatch();
  const { memberLogs, loading } = useSelector((state) => state.api);

  const isAdmin = user?.account_type === "admin";
  const isGym = user?.account_type === "gym";
  const isClusterManager = user?.account_type === "cluster_manager";

  const iniAllFilters = {
    selectedStartDate: prevFilters?.selectedStartDate || "",
    selectedEndDate: prevFilters?.selectedEndDate || "",
    selectedGym: prevFilters
      ? prevFilters.selectedGym
      : !isAdmin && !isClusterManager
      ? {
          label: isGym ? user?.name : user?.gym_name || "",
          value: user?.gym_id || user?.uid || user?.user_id || "",
        }
      : "",
    // lastCheckedIn: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const iniFilters = {
    page: 0,
    limit: 10,
    // last_checkin_days_ago: "",
    start_date: allFilters.selectedStartDate || "",
    end_date: allFilters.selectedEndDate || "",
    user_id: prevClickValues?.userId,
    gym_id: allFilters.selectedGym?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [isPage, setIsPage] = useState(0);
  const iniTbDatas = {
    allData: null,
    pagination: [],
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);
  const initialClickValues = {
    isModOpen: false,
    userId: "",
    type: "",
    clickedType: "",
    sendableStatsQPs: "",
  };
  const [clickValues, setClickValues] = useState(initialClickValues);

  const onClickReset = () => {
    setAllFilters(iniAllFilters);
    setFilters(iniFilters);
  };

  const onCloseModal = () => {
    setClickValues(initialClickValues);
  };

  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym: prevFilters
  //       ? prevFilters.selectedGym
  //       : !isAdmin
  //       ? {
  //           label: isGym ? user?.name : user?.gym_name || "",
  //           value: user?.gym_id || user?.uid || user?.user_id || "",
  //         }
  //       : "",
  //   }));
  // }, [user?.gym_id]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      user_id: prevClickValues?.userId || "",
      start_date: allFilters.selectedStartDate || "",
      end_date: allFilters.selectedEndDate || "",
      gym_id: allFilters.selectedGym?.value || "",
      // last_checkin_days_ago: allFilters.lastCheckedIn?.value || "",
    }));
  }, [isPage, allFilters]);

  useEffect(() => {
    if (filters?.user_id) {
      dispatch(
        fetchMemberLogsData({
          filters: filters,
          token: user?.token,
        })
      );
    }
  }, [filters]);

  useEffect(() => {
    if (memberLogs?.status && memberLogs?.data?.length > 0 && !loading) {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: memberLogs.data,
        pagination: memberLogs?.pagination || [],
      }));
    } else {
      setTbDatas(iniTbDatas);
    }
  }, [memberLogs, loading]);

  const tbColumns = [
    {
      dataField: "checkin_date",
      text: "Member checkin date",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth100 link"
            style={{
              fontWeight: "700",
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                userId: row?.user_id,
                isModOpen: true,
                type: "member",
                clickedType: "last_checkin",
                sendableStatsQPs: row?.checkin_date
                  ? `&start_date=${convertToYYYYMMDD(
                      row.checkin_date
                    )}&end_date=${convertToYYYYMMDD(row.checkin_date)}`
                  : "",
              }))
            }
          >
            {row?.checkin_date || "-"}
          </span>
        );
      },
    },
    {
      dataField: "workout_started",
      text: "workout started",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              columnGap: "8px",
            }}
          >
            {row?.workout_started || 0}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-stopwatch-fill"
              viewBox="0 0 16 16"
              style={{ color: "#008DDA", width: "25px", height: "25px" }}
            >
              <path d="M6.5 0a.5.5 0 0 0 0 1H7v1.07A7.001 7.001 0 0 0 8 16a7 7 0 0 0 5.29-11.584l.013-.012.354-.354.353.354a.5.5 0 1 0 .707-.707l-1.414-1.415a.5.5 0 1 0-.707.707l.354.354-.354.354-.012.012A6.97 6.97 0 0 0 9 2.071V1h.5a.5.5 0 0 0 0-1zm2 5.6V9a.5.5 0 0 1-.5.5H4.5a.5.5 0 0 1 0-1h3V5.6a.5.5 0 1 1 1 0" />
            </svg>
          </span>
        );
      },
    },
    {
      dataField: "workout_pending",
      text: "workout pending",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              columnGap: "8px",
            }}
          >
            {row?.workout_pending || 0}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-clock-history"
              viewBox="0 0 16 16"
              style={{ color: "#FB6D48", width: "25px", height: "25px" }}
            >
              <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7 7 0 0 0-.985-.299l.219-.976q.576.129 1.126.342zm1.37.71a7 7 0 0 0-.439-.27l.493-.87a8 8 0 0 1 .979.654l-.615.789a7 7 0 0 0-.418-.302zm1.834 1.79a7 7 0 0 0-.653-.796l.724-.69q.406.429.747.91zm.744 1.352a7 7 0 0 0-.214-.468l.893-.45a8 8 0 0 1 .45 1.088l-.95.313a7 7 0 0 0-.179-.483m.53 2.507a7 7 0 0 0-.1-1.025l.985-.17q.1.58.116 1.17zm-.131 1.538q.05-.254.081-.51l.993.123a8 8 0 0 1-.23 1.155l-.964-.267q.069-.247.12-.501m-.952 2.379q.276-.436.486-.908l.914.405q-.24.54-.555 1.038zm-.964 1.205q.183-.183.35-.378l.758.653a8 8 0 0 1-.401.432z" />
              <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0z" />
              <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5" />
            </svg>
          </span>
        );
      },
    },
    {
      dataField: "workout_completed",
      text: "workout completed",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              columnGap: "8px",
            }}
          >
            {row?.workout_completed || 0}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-check2-circle"
              viewBox="0 0 16 16"
              style={{ color: "#379C00", width: "25px", height: "25px" }}
            >
              <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" />
              <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" />
            </svg>
          </span>
        );
      },
    },
    {
      dataField: "rating_by_user",
      text: "Trainer Rating By Member",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              columnGap: "8px",
            }}
          >
            {row?.rating_by_user || 0}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-star-fill"
              viewBox="0 0 16 16"
              style={{
                color:
                  parseInt(row?.rating_by_user || 0) > 3
                    ? "#379C00"
                    : "#D90000",
              }}
            >
              <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
            </svg>
          </span>
        );
      },
    },
    {
      dataField: "description",
      text: "description",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.description || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "comment",
      text: "comment",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.comment || "NA"}</span>
        );
      },
    },
  ];

  return (
    <>
      {/* CHECKIN LOGS */}
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Checkin Details Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer minWidth80vw">
          <ModalHeadAndClose
            title={`${clickValues.type} Checkin Logs`}
            onClose={onCloseModal}
          />

          <MemberCheckinLogs
            clickValues={clickValues}
            sendableStatsQPs={clickValues.sendableStatsQPs}
            MLCDate={true}
          />
        </div>
      </Modal>
      {/* ------------- CHECKIN LOGS ----------------- */}

      {/* {!isNotAssignedMembers ? <ProfileInfo info={trainerInfo} /> : null} */}
      {/* <br /> */}
      {/* <ProfileInfo info={prevClickValues.rowData} /> */}
      <div className="modalHeadAndCloseContainer mod-with-details">
        <div className="user-info">
          <div className="user-details">
            <span className="mod-header">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="33"
                viewBox="0 0 33 33"
                fill="none"
                onClick={onClosePrevModal}
              >
                <g id="navigate_before">
                  <path
                    id="icon"
                    d="M19.25 24.75L11 16.5L19.25 8.25L21.175 10.175L14.85 16.5L21.175 22.825L19.25 24.75Z"
                    fill="#1D1B20"
                  />
                </g>
              </svg>
              {prevClickValues.rowData?.name || "NA"}
            </span>
            <span className="mod-regular-text underline">
              +91 {prevClickValues.rowData?.mobile || ""}
            </span>
            <span className="mod-regular-text lowercase underline">
              {prevClickValues.rowData?.email || ""}
            </span>
            <span className="mod-light-text">
              {prevClickValues.rowData?.gym_name || ""}
            </span>
            {!isNotAssignedMembers && (
              <>
                <span className="mod-regular-text underline">
                  Trainer - {trainerInfo?.name || ""}{" "}
                  <small className="lowercase">
                    (+91 {trainerInfo?.mobile || ""}/{trainerInfo?.email || ""})
                  </small>
                </span>

                <span className="mod-light-text underline">
                  Trainer Shift - {trainerInfo?.shiftTiming || ""}
                </span>
                <span className="mod-light-text underline">
                  Trainer Last Checked In -{" "}
                  {convertStraight(trainerInfo?.last_checkin) || "-"}{" "}
                  {convertTimeRangeHHMMSS(trainerInfo?.checkin_time) || ""}{" "}
                  {trainerInfo?.last_checkin_days_ago
                    ? `(${trainerInfo.last_checkin_days_ago?.replace(
                        /_/g,
                        " "
                      )})`
                    : ""}
                </span>
              </>
            )}
          </div>
        </div>

        <button
          type="button"
          className="closeModalBtn"
          onClick={onClosePrevModal}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-x-lg"
            viewBox="0 0 16 16"
          >
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
          </svg>
        </button>
      </div>

      <MemberTableFilters
        user={user}
        allFilters={allFilters}
        setAllFilters={setAllFilters}
        onClickReset={onClickReset}
        MCUTSDate={true}
        onlyDateRanger={true}
      />

      {loading ? (
        <ReactVortoxSpinner />
      ) : (
        <div className="tab-view-table-container overflowAuto separatedTable">
          <PaymentLinkTable
            tableData={tbDatas.allData}
            tableColumns={tbColumns}
            tablePagination={tbDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
          />
        </div>
      )}
    </>
  );
};

export default MemberDetail;
